import * as deviceInfoActions from "../state/actions/deviceInfo.actions";

const registerGlobalEventHandlers = store => {
  window.addEventListener("resize", () => {
    store.dispatch(deviceInfoActions.triggerUpdate());
  });
  store.dispatch(deviceInfoActions.triggerUpdate());
};

export default registerGlobalEventHandlers;
